import { useState } from 'react'
import { Box, Button, Link } from '@mui/material'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { googleUserAtom } from 'infrastructure/googleDrive'
import { createSpreadsheet } from 'infrastructure/googleDrive'

const TEMPLATE_HEADERS = ['Grade', 'Unit Number', 'Unit Name', 'Standard']

const TEMPLATE_SAMPLE_DATA = [
  ['5', '1', 'Unit 1: Introduction to Volume and Decimals', 'MA.5.GR.3.1'],
  ['5', '1', 'Unit 1: Introduction to Volume and Decimals', 'MA.5.GR.3.2'],
]

export function CreateTemplateButton({
  onTemplateCreated,
}: {
  onTemplateCreated?: (spreadsheetId: string) => void
}) {
  const guser = useAtomValue(googleUserAtom)
  const [loading, setLoading] = useState(false)
  const [spreadsheetUrl, setSpreadsheetUrl] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  const handleCreateTemplate = async () => {
    if (!guser.credential?.accessToken) return

    setLoading(true)
    setError(null)

    try {
      const id = await createSpreadsheet(
        guser.credential.accessToken,
        'Scope and Sequence Template',
        [
          {
            title: 'Template',
            data: [TEMPLATE_HEADERS, ...TEMPLATE_SAMPLE_DATA],
            frozenRowCount: 1,
          },
        ],
      )
      setSpreadsheetUrl(`https://docs.google.com/spreadsheets/d/${id}/edit`)
      onTemplateCreated?.(id)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create template')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Button
        variant="contained"
        onClick={handleCreateTemplate}
        disabled={loading}
      >
        {loading ? 'Creating Template...' : 'Create Template'}
      </Button>
      {error && (
        <Box
          component="span"
          sx={{ color: 'error.main', fontSize: '0.875rem' }}
        >
          {error}
        </Box>
      )}
      {spreadsheetUrl && (
        <Link
          href={spreadsheetUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ fontSize: '0.875rem' }}
        >
          Open Template
        </Link>
      )}
    </Box>
  )
}
